<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">EDITANDO DETALLE</h1>
    </section>
    <form [formGroup]="editPersonForm" (ngSubmit)="saveChanges(editPersonForm.value)">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="70">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input type="text" matInput formControlName="nombre">
              <mat-error *ngIf="editPersonForm.controls['nombre'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editPersonForm.controls['nombre'].hasError('cannotContainSpace')">
               El nombre no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="30">
            <mat-form-field appearance="outline">
              <mat-label>Comisión</mat-label>
              <input type="number" matInput formControlName="comision">
              <mat-error *ngIf="editPersonForm.controls['comision'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editPersonForm.controls['comision'].hasError('min')">
                Debe ser mayor a 0
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="60">
            <mat-form-field appearance="outline">
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="tel">
              <mat-hint>Éste será el nombre de usuario</mat-hint>
              <mat-error *ngIf="editPersonForm.controls['tel'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editPersonForm.controls['tel'].hasError('cannotContainSpace')">
                El teléfono no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="40">
            <mat-form-field appearance="outline">
              <mat-label>Cambiar contraseña</mat-label>
              <input type="password" matInput formControlName="newPassword">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="estado">
                <mat-option *ngFor="let option of options" [value]="option.value">
                  {{option.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <h2 class="cardHeader">Datos del vehículo</h2>
            <mat-form-field appearance="outline">
              <mat-label>Patente</mat-label>
              <input type="text" matInput formControlName="patente">
              <mat-error *ngIf="editPersonForm.controls['patente'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editPersonForm.controls['patente'].hasError('cannotContainSpace')">
                La patente no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="60">
            <mat-form-field appearance="outline">
              <mat-label>Tarjeta de Circulación</mat-label>
              <input type="text" matInput formControlName="tarjetaC">
              <mat-error *ngIf="editPersonForm.controls['tarjetaC'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editPersonForm.controls['tarjetaC'].hasError('cannotContainSpace')">
                La tarjeta no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="40">
            <mat-form-field appearance="outline">
              <mat-label>Vencimiento</mat-label>
              <input matInput [matDatepicker]="calendar" formControlName="vencT">
              <mat-datepicker-toggle matSuffix [for]="calendar"></mat-datepicker-toggle>
              <mat-datepicker #calendar></mat-datepicker>
              <mat-error *ngIf="editPersonForm.controls['vencT'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="60">
            <mat-form-field appearance="outline">
              <mat-label>Licencia de Conducir</mat-label>
              <input type="text" matInput formControlName="licencia">
              <mat-error *ngIf="editPersonForm.controls['licencia'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="editPersonForm.controls['licencia'].hasError('cannotContainSpace')">
                La licencia no puede ser un espacio en blanco
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="40">
            <mat-form-field appearance="outline">
              <mat-label>Vencimiento</mat-label>
              <input matInput [matDatepicker]="calendario" formControlName="vencL">
              <mat-datepicker-toggle matSuffix [for]="calendario"></mat-datepicker-toggle>
              <mat-datepicker #calendario></mat-datepicker>
              <mat-error *ngIf="editPersonForm.controls['vencL'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <br>
      <div fxLayout="row" fxLayoutAlign="start center">
        <button type="submit" mat-raised-button [disabled]="!editPersonForm.valid" class="save-changes">GUARDAR CAMBIOS</button>
        <button routerLink="/personal" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>